window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {
  var selectors = {
    productJson: '[data-product-json]',
    mobileStockMessageSplit: '.product-details-stock-message-mobile-split',
    bottom: '.product-details-bottom',
    stockMobile: '.product-details-stock-mobile',
    right: '.product-right'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    productJson = $(selectors.productJson, container).html()
    if (!productJson) {
      return;
    }
    this.product = JSON.parse(productJson)

    this.namespace = '.product';
    this.$right = $(selectors.right, this.$container)
    this.setupVue(this.$right[0]);
    this.getVariants();
    this.setupVideo();
    this.reviewToggle();
    this.sizeToggle();
    this.cardVariantToggle();
    this.$mobileStockMessageSplit = $(selectors.mobileStockMessageSplit, this.$container);
    if (this.$mobileStockMessageSplit.length > 0) {
      this.onScroll();
      $(window).on('scroll' + this.namespace + ' resize' + this.namespace, _.throttle(this.onScroll.bind(this), 20));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(window).off(this.namespace);
      this.rightView.$destroy();
    },

    reviewToggle: function() {
      const reviewContainer = document.querySelector('.product-review');

      this.reviewTriggers = [].slice.call(
        document.querySelectorAll('.product__review-toggle')
      );
  
      this.reviewTriggers.forEach(trigger => {
        // ada : support keyboard
        ['click', 'keypress'].forEach(event => {
          trigger.addEventListener(event, e => {
            const key = e.which || e.keyCode;
            if (key === 13 || e.type === 'click') {
              reviewContainer.classList.toggle('open');
            }
          });
        });
      });
    },

    sizeToggle: function() {
      const sizeGuideContainer = document.querySelector('.product-size-guide');

      this.reviewTriggers = [].slice.call(
        document.querySelectorAll('.product-size-guide__toggle')
      );
  
      this.reviewTriggers.forEach(trigger => {
        // ada : support keyboard
        ['click', 'keypress'].forEach(event => {
          trigger.addEventListener(event, e => {
            const key = e.which || e.keyCode;
            if (key === 13 || e.type === 'click') {
              sizeGuideContainer.classList.toggle('open');
            }
          });
        });
      });
    },

    cardVariantToggle: function() {
      const valueTitle = document.querySelector('.product-details-bottom .headline-s');
      const valuePrice = document.querySelector('.product-details-price span');

      this.valueToggles = [].slice.call(
        document.querySelectorAll('.value-toggle')
      );

      this.selectOption = [].slice.call(
        document.querySelectorAll('[data-select-name]')
      );
  
      this.valueToggles.forEach(value => {
        // ada : support keyboard
        ['click', 'keypress'].forEach(event => {
          value.addEventListener(event, e => {
            const key = e.which || e.keyCode;
            if (key === 13 || e.type === 'click') {

              this.valueToggles.forEach(currentValues => {
                currentValues.classList.remove('current')
              })

              this.selectOption.forEach(option => {
                option.selected = ''

                if(option.dataset.selectName === value.dataset.title) {
                  option.selected = 'selected'
                }
              })

              value.classList.add('current')

              valueTitle.innerHTML = value.dataset.displayTitle;
              valuePrice.innerHTML = value.dataset.price;
            }
          });
        });
      });
    },

    setupVideo: function() {
      $videos = $('video', this.$right)
      $videos.each(function(i, video) {
        var insertIndex = parseInt($(video).attr('data-position'));
        if(insertIndex < 2) {
          return;
        }
        $(`.product-scroll > :nth-child(${insertIndex})`).after(video);
        if ( $('.product-scroll').children().length < insertIndex ) {
          $('.product-scroll').append(video);
        }
        initVideos();
      }.bind(this))
    },

    setupVue: function(el) {
      this.data = {
        product: this.product,
        colorsVisible: false,
        backInStockVisible: false,
        backInStockConfirmed: false,
        sizesVisible: false,
        variants: []
      }

      var colorVariant = {
        props: ['variant', 'product_id', 'hideColors'],
        template: `
          <a
            v-bind:href="variant.url"
            v-on="{ click: $event => hideColors($event, product_id == variant.id) }"
            class="large-up--headline-xs medium-down--sans-serif-copy-s variant"
          >
            <div class="title">{{variant.title}}</div>
            <div class="swatch"><img v-bind:src="variant.swatch" /></div>
          </a>
        `
      };

      this.rightView = new Vue({
        el: el,
        data: this.data,
        components: {
          "color-variant": colorVariant
        },
        methods: {
          showColors: function () {
            this.colorsVisible = true;
          },
          hideColors: function (e, preventDefault = true) {
            if (e && preventDefault) {
              e.preventDefault();
            }
            this.colorsVisible = false;
          },
          showBackInStock: function () {
            this.backInStockConfirmed = false;
            this.backInStockVisible = true;
          },
          hideBackInStock: function () {
            this.backInStockVisible = false;
          },
          submitBackInStock: function(e) {
            e.preventDefault();
            $el = $(e.target)
            email = $('input[name="email"]', $el).val();
            variant = $('input[name="variant"]', $el).val();
            product = $('input[name="product"]', $el).val();
            _this = this;
            BIS.create(email, variant, product).then( function(resp) {
              setTimeout(function() {
                _this.backInStockConfirmed = true;
                setTimeout(_this.hideBackInStock, 2000);
              }, 1000);
            });
          }
        }
      })
    },

    onScroll: function (e) {
      var bottomOffset = $(selectors.bottom, this.$container).offset().top;
      var originalPosition = $(selectors.stockMobile, this.$container).offset().top;
      if (bottomOffset < originalPosition) {
        this.$mobileStockMessageSplit.addClass('stuck');
      } else {
        this.$mobileStockMessageSplit.removeClass('stuck');
      }
    },

    getVariants: function() {
      _this = this;
      $.ajax({
        type: "GET",
        url: '/search.json?view=swatches&type=product&q=product_type:' + this.product.type,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: function(error) {
        },
        success: function(response) {
          _this.rightView.variants = response;
        }
      });
    }
  });

  return Product;
})();


// Email Submit

function onSignupSubmit($el, options = {}) {
  $el.on('submit', 'form.signup', function(e){
    e.preventDefault();
    var $el = $(e.target);
    var $container = $(e.delegateTarget);
    $container.attr('data-state', '');
    var data = $el.serialize();
    $email = $("input[type='email']", $el);
    $submit = $("input[type='submit']", $el);

    if (!$email[0].checkValidity()) {
      $('.error-feedback', $container).text('Please check your email address');
      $container.attr('data-state', 'error');
      return;
    }

    $email.prop('disabled', true);
    $submit.prop('disabled', true);
    return $.ajax({
      type: "GET",
      url: $el.attr("action").replace('/post', '/post-json'),
      data: data,
      cache: false,
      dataType: "jsonp",
      jsonp: "c",
      contentType: "application/json; charset=utf-8",
      error: function(error) {
        $email.prop('disabled', false);
        $submit.prop('disabled', false);

        $('.error-feedback', $container).text('An internal error has occured');

        $container.attr('data-state', 'error');
      },
      success: function(data) {
        $email.prop('disabled', false);
        $submit.prop('disabled', false);

        if ((data.result === "success") ||
          (data.msg && data.msg.indexOf("already subscribed") >= 0) ||
          (data.msg && data.msg.indexOf("too many recent signup requests") >= 0)
        ) {
          Cookies.set('email_collected', true, { expires: 30 });
          setTimeout(function() {
            $container.attr('data-state', 'success');
          }, 1000);
          if (options.success) {
            options.success();
          }
        } else {
          error = data.msg.split(' - ')[1];
          $container.attr('data-state', 'error');
          if (options.error) {
            options.error();
          }
        }
      },
      error: options.error
    });
  });
}

window.initVideos = function() {
  var $videos = $('video')
  var videoWaypoints = [];
  WindowResize.onResize({
    mobile: function(firstRun) {
      $videos.each(function(){
        this.pause();
      });
      if (videoWaypoints.length > 0) {
        console.log('video disable');
        _.each(videoWaypoints, function(waypoint) {
          waypoint.disable();
        });
      }
    },

    desktop: function(firstRun) {
      if (videoWaypoints.length > 0) {
        console.log('video enable');
        _.each(videoWaypoints, function(waypoint) {
          waypoint.enable();
          $videos.inViewport({partially: true}).each(function(){
            this.play();
          })
        });
        return;
      }
      console.log('video init');
      videoWaypoints = _.flatten([
        $videos.waypoint({
          handler: function(direction){
            if (direction == 'up') {
              this.element.play();
              console.log('video play');
            } else {
              this.element.pause();
              console.log('video pause');
            }
          },
          offset: function() {
            return -this.element.clientHeight
          },
          continuous: true
        }),

        $videos.waypoint({
          handler: function(direction){
            if (direction == 'up') {
              this.element.pause();
              console.log('video pause');
            } else {
              this.element.play();
              console.log('video play');
            }
          },
          offset: '100%',
          continuous: true
        })
      ])
    }
  });
}

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



WindowResize = {

  onResize: function({mobile, desktop}){

    this.mobile.push(mobile);

    this.desktop.push(desktop);



    this.isMobile = this.checkViewportSize();

    this.firstRun = false;

    $(window).on('resize', _.debounce(function(){

      this.isMobile = this.checkViewportSize();

    }, 100).bind(this));

  },



  checkViewportSize: function() {

    var width = $(window).width();

    var wasMobile = this.isMobile;

    var firstRun = this.firstRun;

    var nowMobile = (width < 750);

    if (nowMobile && (!wasMobile || firstRun)) {

      console.log('mobile')

      this.mobile.forEach(function(fn) {

        fn(firstRun);

      });

      return true;

    } else if (!nowMobile && (wasMobile || this.firstRun)) {

      console.log('desktop')

      this.desktop.forEach(function(fn) {

        fn(firstRun);

      });

      return false;

    }

    return nowMobile;

  },



  firstRun: true,

  mobile: [],

  desktop: []



}

$(document).ready(function() {

  Shopify.Image = slate.Image;
  Shopify.formatMoney = slate.Currency.formatMoney;


  // Clear image before replacing
  rivets.binders.src = function(el, value) {
    if (el.src != value) {
      el.src = '';
      return el.src = value != null ? value : '';
    }
    return el.src;
  };

  CartJS.init(JSON.parse($('[data-cart-json]').text()), JSON.parse($('[data-cart-settings-json]').text()));

  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
  
  // CLICK TO COPY -- CLASS ADDED ON PARENT AFTER CLICK

  const copyElement = document.querySelectorAll('.copyable');

  copyElement.forEach(elem => {
    elem.addEventListener('click', () => {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(elem);
      selection.removeAllRanges();
      selection.addRange(range);

      try {
        document.execCommand('copy');
        selection.removeAllRanges();

        // elem.textContent = 'Copied to Clipboard!';
        elem.parentElement.classList.add('success');

        setTimeout(() => {
          // elem.textContent = original;
          elem.parentElement.classList.remove('success');
        }, 1200);
      } catch(e) {
        const errorMsg = document.querySelector('.error-msg');
        errorMsg.parentElement.classList.add('show');

        setTimeout(() => {
          errorMsg.parentElement.classList.remove('show');
        }, 1200);
      }
    });
  });
});

